import {
  useEffect,
  useState,
  type Dispatch,
  type JSX,
  type SetStateAction,
} from 'react';

import {
  Typography,
  truncateText,
  Tooltip,
  useTheme,
  getStoreValue,
  clearStore,
  Icon,
  Toastify,
  isTextTruncated,
} from 'pixel-react';

import type { Test_Optimize_ResponseObject } from '@/store/commonApiType/testOptimizeUserType';
import { useUserSignoutMutation } from '@/store/header/headerSlice';

import styles from './Profile.module.scss';
import ProfileForm from './ProfileForm';
import { getWebSiteHostName } from '../Header/utils';

const ProfileModal = ({
  setIsOpen,
  setIsDrawerOpen,
}: {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>;
}): JSX.Element => {
  const { applyTheme } = useTheme();
  const username = getStoreValue(
    'test-optimize-user',
  ) as Test_Optimize_ResponseObject;
  const userDetails = username;
  const userData = userDetails?.responseObject;
  const [theme, setTheme] = useState<string | object>('');
  const [userProfileDrawerOpen, setUserProfileDrawerOpen] = useState(false);
  useEffect(() => {
    const themeValue = getStoreValue('current-theme');
    setTheme(themeValue || '');
    applyTheme(themeValue === 'dark' ? 'ff-dark-theme' : 'ff-light-theme');
  }, [applyTheme, theme]);
  //TODO : will be taking this for next release
  // const handleToggleTheme = (): void => {
  //   setStoreValue('current-theme', theme === 'dark' ? 'light' : 'dark');
  //   setTheme(prevTheme => (prevTheme === 'dark' ? 'light' : 'dark'));
  // };
  const [userSignout] = useUserSignoutMutation();
  const signoutHandler = () => {
    userSignout({
      refreshToken: userData?.refresh_token as string,
      signOutType: 'APP',
    })
      .unwrap()
      .then((response: { responseCode: number; message: string }) => {
        if (response) {
          clearStore();
          setIsOpen(false);
          // const url = `${getWebSiteHostName()}/signin?product=fireflink-platform`;
          window.location.replace('/signin?product=fireflink-platform');
        }
      })
      .catch((error: { message: string }) => {
        console.error('Error fetching cloud platform data:', error);
      });
  };
  const handleClose = () => {
    setUserProfileDrawerOpen(false);
    setIsDrawerOpen(false);
  };
  const handleOpen = () => {
    setUserProfileDrawerOpen(true);
    setIsDrawerOpen(true);
  };
  return (
    <>
      <div
        className={`${styles.ff_profile_modal} ${userProfileDrawerOpen ? styles.hidden_modal : ''}`}
      >
        <div className={styles.ff_profile_modal_content}>
          <div className={styles.name_container} onClick={handleOpen}>
            <Tooltip
              title={
                isTextTruncated(userData?.name || '', 100, 'pixel')
                  ? userData?.name
                  : ''
              }
            >
              <Typography
                lineHeight="18px"
                color="var(--text-color)"
                fontWeight="medium"
                as="div"
                className={styles.user_name}
              >
                {truncateText(userData?.name || '', 100, 'pixel')}
              </Typography>
            </Tooltip>

            <div className={styles.edit_icon}>
              <Tooltip title="Edit">
                <Icon color="var(--brand-color)" hoverEffect name="edit" />
              </Tooltip>
            </div>
          </div>
          <Typography
            className={styles.ff_profile_modal_content_email}
            lineHeight="18px"
            color={'var(--description-text)'}
            fontWeight="medium"
            as="div"
          >
            {userData?.userName && userData?.userName?.length > 17 ? (
              <Tooltip title={userData.userName}>
                {truncateText(userData?.userName, 17)}
              </Tooltip>
            ) : (
              userData?.userName
            )}
          </Typography>
        </div>
        {/* TODO : will be taking this for next release */}
        {/* <div className={styles.ff_profile_modal_switch}>
          <Typography
            children="Switch mode"
            fontSize={10}
            lineHeight="12px"
            color={'var(--text-color)'}
            fontWeight="semi-bold"
          />
          <div>
            <Toggle
              checked={theme === 'dark'}
              id="toggle"
              onChange={handleToggleTheme}
              size="medium"
              icon={{
                checked: { name: 'moon_stars_icon', width: 14, height: 14 },
                unchecked: { name: 'sun_icon', width: 14, height: 14 },
              }}
            />
          </div>
        </div> */}
        <div
          className={styles.ff_profile_modal_footer}
          onClick={signoutHandler}
        >
          <Typography
            children="Sign Out"
            fontSize={10}
            lineHeight="15px"
            fontWeight="medium"
          />
        </div>
      </div>
      {userProfileDrawerOpen && <ProfileForm onClose={handleClose} />}
      <Toastify />
    </>
  );
};

export default ProfileModal;
